/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type HomeTabDetailImageResponseType = {
  id: number
  /** 1 = selected tab image, 2 = unselected tab image. */
  image_type: number
  url_small: string
  url_medium: string
  url_large: string
}

export type HomeTabDetailSegmentationResponseType = {
  id: number
  type_id: number
  segment_type_id: number
  segment_type_name: string
}

export type HomeTabDetailComponentResponseType = {
  id: number
  component_name: string
  homepage_tabbing_component_type_id: number
  homepage_tabbing_component_type_name: string
  position: number
  start_date_time?: string
  end_date_time?: string
  /** Marks a component reserved for the "Semua" tab. */
  all_tab_only?: boolean
}

export type HomeTabDetailResponseType = {
  data: {
    id: number
    name: string
    display_name: string
    homepage_tabbing_type_id: number
    tabbing_category: number
    slot: number
    position: number
    status: number
    targeting_type_id: number
    targeted_user_ids?: number[]
    targeted_segmentations?: HomeTabDetailSegmentationResponseType[]
    is_recurring_schedule: boolean
    start_date_time?: string
    end_date_time?: string
    images?: HomeTabDetailImageResponseType[]
    components?: HomeTabDetailComponentResponseType[]
    /** Hub ids the tab runs on. `[0]` means every hub; empty means none mapped. */
    location_ids?: number[]
  }
}

export const getHomeTabDetail = (id: string) =>
  axiosInstanceApiGateway.Get<HomeTabDetailResponseType, true>({
    url: `/browse/internal/v1/homepage-tabbings/${id}`,
  })

export type HomeTabImagePayloadType = {
  image_type: number
  url_small: string
  url_medium: string
  url_large: string
}

export type HomeTabSegmentationPayloadType = {
  type_id: number
  segment_type_id: number
}

export type CreateHomeTabPayloadType = {
  name: string
  display_name: string
  homepage_tabbing_type_id: number
  tabbing_category: number
  slot: number
  /** `<= 0` lets the API resolve it to MAX(position) + 1 within the slot. */
  position: number
  targeting_type_id: number
  targeted_user_ids: number[]
  /** RFC3339 UTC — omitted for Default tabs, which cannot carry a schedule. */
  start_date_time?: string
  end_date_time?: string
  is_recurring_schedule: boolean
  images: HomeTabImagePayloadType[]
  targeted_segmentations: HomeTabSegmentationPayloadType[]
  /** `[0]` = Semua Hub. Specific ids limit the tab to those hubs. */
  location_ids: number[]
}

export type CreateHomeTabResponseType = {
  data: {
    id: number
    name: string
    display_name: string
    status: number
  }
}

export type UpdateHomeTabPayloadType = CreateHomeTabPayloadType & {
  id: number
  /** 1=Draft, 2=Active, 3=Scheduled, 4=Ended, 5=Inactive */
  status: number
}

export type UpdateHomeTabResponseType = CreateHomeTabResponseType

export const createHomeTab = (payload: CreateHomeTabPayloadType) =>
  axiosInstanceApiGateway.Post<CreateHomeTabResponseType, true>({
    url: '/browse/internal/v1/homepage-tabbings',
    data: payload,
  })

/**
 * Images, segmentations and hubs are replaced wholesale, so the payload must
 * carry the full set.
 */
export const updateHomeTab = (payload: UpdateHomeTabPayloadType) =>
  axiosInstanceApiGateway.Put<UpdateHomeTabResponseType, true>({
    url: `/browse/internal/v1/homepage-tabbings/${payload.id}`,
    data: payload,
  })
